import { useLoaderData, useNavigate } from "react-router-dom";
import schoolsAPI from "../../services/schools";
import MeaPage from "../../components/MeaPage";

import { PERMISSION_SCHOOL_DETAILS, PERMISSION_SCHOOL_MEMBERS, PERMISSION_SCHOOL_POLICIES, PERMISSION_SCHOOL_TRAININGS, PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_EVENTS, PERMISSION_TRAINING_PAYMENTS, PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS, PERMISSION_TRAINING_STUDENTS, PERMISSION_TRAINING_TEACHERS } from "../../permissions";
import { useAuthContext } from "../../hooks/useAuthContext";

export async function loader({ params }) {
  const result = await schoolsAPI.GetOneSchool(params.schoolId);
  return { school: result?.data };
}

export function SecretariatHome() {
  const { school } = useLoaderData();
  const { hasPermission } = useAuthContext();
  const navigate = useNavigate();

  return (
    <>
      <MeaPage
        showBackButton={false}
        header={
          <div>
            <div
              style={{
                height: "180px",
                background:
                  'url("/images/school-empty-cover.jpeg") no-repeat',
                backgroundSize: "cover",
              }}
            ></div>
            <div className="px-4 py-0 md:px-6 lg:px-8 ">
              <div
                className="flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between relative"
                style={{
                  marginTop: "-2rem",
                  top: "-50px",
                  marginBottom: "-70px",
                }}
              >
                <div>
                  <div
                    style={{
                      width: "140px",
                      height: "140px",
                      borderRadius: "10px",
                    }}
                    className="mb-3 surface-card shadow-2 flex align-items-center justify-content-center"
                  >
                    <img
                      src={school?.avatar
                        ? school?.avatar + "?" + school?.updated_at
                        : "/images/school-empty-logo.svg"}
                      width="90%"
                    />
                  </div>
                  <div className="text-900 text-3xl font-medium mb-1">
                    {school?.name}
                  </div>
                  <div className="text-600 font-medium mb-3">
                    <span className="bg-teal-50 text-teal-700 px-3 py-1 border-round text-sm font-semibold">
                      Espace Secretariat
                    </span>
                  </div>
                  {/* <p className="mt-0 mb-0 text-700 text-xl">
                    {school?.presentation}
                  </p>
                  <div className="text-600 mb-3 font-medium">
                    <span>{school?.address}</span>
                  </div> */}
                </div>
                <div className="mt-3 lg:mt-0">
                </div>
              </div>
            </div>
          </div>
        }
      >
        <div className="grid grid-nogutter pt-4">

          {hasPermission(PERMISSION_SCHOOL_TRAININGS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/presences")}
            >
              <div className="flex">
                <img src="/images/icons/checklist.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="1" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Feuilles de présence</span>
                  <span className="text-600 font-medium mb-2">Gérer les absences des élèves et remplacements des enseignants</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_STUDENTS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/students")}
            >
              <div className="flex">
                <img src="/images/icons/members.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="3" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Liste des élèves</span>
                  <span className="text-600 font-medium mb-2">Consulter la liste des élèves par formation</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_TEACHERS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/teachers")}
            >
              <div className="flex">
                <img src="/images/icons/teachers.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="teachers" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Liste des enseignant(e)s</span>
                  <span className="text-600 font-medium mb-2">Consulter la liste des enseignant(e)s</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_CLASSES.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/classes")}
            >
              <div className="flex">
                <img src="/images/icons/trainings.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="2" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Les classes</span>
                  <span className="text-600 font-medium mb-2">Consulter/imprimer les classes et groupes d'élèves</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_PAYMENTS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/payments")}
            >
              <div className="flex">
                <img src="/images/icons/atm-card.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="4" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Gestion de paiements</span>
                  <span className="text-600 font-medium mb-2">Suivre les encaissements et mettre à jour les paiements</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/slot-change-requests")}
            >
              <div className="flex">
                <img src="/images/icons/exchange.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="5" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Changements de créneau</span>
                  <span className="text-600 font-medium mb-2">Consulter et traiter les demandes de changement de créneau</span>
                </div>
              </div>
            </div>
          </div>}
          {hasPermission(PERMISSION_TRAINING_EVENTS.LIST) && <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => navigate("/school/" + school?.id + "/secretariat/agenda")}
            >
              <div className="flex">
                <img src="/images/icons/registration.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="Agenda" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Agenda</span>
                  <span className="text-600 font-medium mb-2">Consulter les événements de la formation en cours.</span>
                </div>
              </div>
            </div>
          </div>}

        </div>
      </MeaPage>
    </>
  );
}
